import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../core/globals/api-constants';
import {map} from 'rxjs/operators';

@Injectable()
export class ApiService {
  client: any;

    constructor(
        private http: HttpClient,
       ) { }

    private user: any;
    public setUser(data) {
      this.user = data;
    }

    setHeaders() {
      let headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      if (this.user) { headers = headers.append('Buid-Context', this.user.buId); }
      if (this.client) { headers = headers.append('Client-Context', this.client.client); }
      return headers;
    }

    public setClient(client) {
      this.client  = client;
    }

    private jsonToQueryString(json: any) {
      return '?' +
        Object.keys(json).map((key) => {
            if (Array.isArray(json[key])) {
                let str = '';
                json[key].forEach((item, index) => {
                    str += encodeURIComponent(key) + '=' +
                        encodeURIComponent(item) + (index < json[key].length - 1 ? '&' : '');
                });
                return str;
            } else {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }
        }).join('&');
    }

    private constructRequestUrl(url: string, queryParams = {}) {
      let requestUrl = ApiConstants.baseURL + ApiConstants.apiURLs[url];

      // Replace embeded url params
      const regExp = /{([a-zA-Z-_]+)}/;
      while (requestUrl.match(regExp)) {
        const matchData = requestUrl.match(regExp);
        requestUrl = requestUrl.replace(matchData[0], queryParams[matchData[1]] || this.user[matchData[1]]);
        delete queryParams[matchData[1]];
      }

        // Append remaining query params
      if (Object.keys(queryParams).length) {
        requestUrl = requestUrl + this.jsonToQueryString(queryParams);
      }

      return requestUrl;
    }

    public httpRequest(request): Observable<any> {
      const requestUrl = this.constructRequestUrl(request.url, request.queryParams);
      const options = { headers : this.setHeaders()};
      let httpRequest;

      switch (request.type.toUpperCase()) {
        case 'GET': httpRequest = this.http.get(requestUrl, options); break;
        case 'POST': httpRequest = this.http.post(requestUrl, request.body, options).pipe(map((response: any) => response)); break;
        case 'PUT': httpRequest = this.http.put(requestUrl, request.body, options).pipe(map((response: any) => response)); break;
        case 'DELETE':
          if (request.body) {
            const newOptions = {
               headers: this.setHeaders(),
               body: request.body,
            };
            httpRequest = this.http.delete(requestUrl, newOptions);
          } else {
            httpRequest = this.http.delete(requestUrl, options);
          }
          break;
        default: console.log('incorrect request type'); return;
      }
      return httpRequest;
    }

    public httpRequestAsText(request): Observable<any> {
      const requestUrl = this.constructRequestUrl(request.url, request.queryParams);
      const options = { headers : this.setHeaders(), responseType: 'text' as 'json'};
      let httpRequest;

      switch (request.type.toUpperCase()) {
        case 'GET': httpRequest = this.http.get(requestUrl, options); break;
        case 'POST': httpRequest = this.http.post(requestUrl, request.body, options).pipe(map((response: any) => response)); break;
        case 'PUT': httpRequest = this.http.put(requestUrl, request.body, options).pipe(map((response: any) => response)); break;
        case 'DELETE':
          if (request.body) {
            const newOptions = {
               headers: this.setHeaders(),
               body: request.body,
            };
            httpRequest = this.http.delete(requestUrl, newOptions);
          } else {
            httpRequest = this.http.delete(requestUrl, options);
          }
          break;
        default: console.log('incorrect request type'); return;
      }
      return httpRequest;
    }

    public httpRequestBlob(request): Observable<any> {
      const requestUrl = this.constructRequestUrl(request.url, request.queryParams);
      let header = new HttpHeaders();
      header = header.append('Buid-Context', this.user.buId);
      if (this.client){header = header.append('Client-Context', this.client.client); }
      const headers = request.fileUpload ? header : this.setHeaders();
      const options = { headers, responseType: 'blob' as 'json', observe: "response" as 'body'};
      let httpRequest;

      switch (request.type.toUpperCase()) {
        case 'POST': httpRequest = this.http.post(requestUrl, request.body, options).pipe(map((response: any) => response)); break;
        case 'GET': httpRequest = this.http.get(requestUrl, options); break;
        default: console.log('incorrect request type'); return;
      }
      return httpRequest;
    }

    public httpRequestFileAndModel(request): Observable<any> {
      const requestUrl = this.constructRequestUrl(request.url, request.queryParams);
      let header = new HttpHeaders();
      header = header.append('Buid-Context', this.user.buId);
      if (this.client){header = header.append('Client-Context', this.client.client); }
      const options = { headers : header};
      return this.http.post(requestUrl, request.body, options).pipe(map((response: any) => response));
    }

    httpRequestDownloadZipFile(request) {
      const requestUrl = this.constructRequestUrl(request.url, request.queryParams);
      let header = new HttpHeaders();
      header = header.append('Buid-Context', this.user.buId);
      if (this.client){header = header.append('Client-Context', this.client.client); }
      const options = { headers: header, responseType: 'arraybuffer' as 'json', observe: "response" as 'body'};
      return this.http.get(requestUrl, options);
    }

    public httpRequestFileUploadProgress(request): Observable<HttpEvent<any>> {
      const requestUrl = this.constructRequestUrl(request.url, request.queryParams);
      let header = new HttpHeaders();
      header = header.append('Buid-Context', this.user.buId);
      if (this.client){header = header.append('Client-Context', this.client.client); }
      const headers = request.fileUpload ? header : this.setHeaders();
      const options = { headers, reportProgress: true, observe: "events" as "body" };
      let httpRequest;

      switch (request.type.toUpperCase()) {
        case 'POST': httpRequest = this.http.post(requestUrl, request.body, options); break;
        case 'GET': httpRequest = this.http.get(requestUrl, options); break;
        default: console.log('incorrect request type'); return;
      }
      return httpRequest;
    }
    public checkResponseStatus(request): Observable<any> {
      const requestUrl = this.constructRequestUrl(request.url, request.queryParams);
      let httpRequest;

      switch (request.type.toUpperCase()) {

        case 'POST': httpRequest = this.http.post(requestUrl, request.body, {
          headers: this.setHeaders(),
          observe: 'response'
        }).pipe(map((response: any) => response)); break;
      }
      return httpRequest;
    }
}
